/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface avatarPlaceHolderProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const avatarPlaceHolder: React.FC<avatarPlaceHolderProps> = ({size, ...props}) => (
  <svg viewBox="0 0 60 60" fill="currentColor" width={ size || "60" } height={ size || "60" } {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <circle cx="30" cy="30" r="30" fillOpacity=".2" />
      <path d="M38.457 39H21.542C20.14 39 19 37.82 19 36.367V25.69c0-1.452 1.14-2.633 2.542-2.633h3.452L25.296 22A1.264 1.264 0 0 1 26.529 21h6.942c.583 0 1.099.422 1.235 1.007l.008.036.276 1.014h3.468c1.402 0 2.542 1.18 2.542 2.633v10.677C41 37.819 39.859 39 38.457 39zm-8.456-2.571c-3.033 0-5.501-2.538-5.501-5.657 0-3.12 2.468-5.658 5.5-5.658 3.033 0 5.5 2.538 5.5 5.658 0 3.119-2.467 5.657-5.5 5.657zm0-10.286c-2.482 0-4.501 2.076-4.501 4.629 0 2.552 2.02 4.628 4.5 4.628 2.482 0 4.5-2.076 4.5-4.628 0-2.553-2.019-4.63-4.5-4.63z"
      />
    </g>
  </svg>
);
avatarPlaceHolder.displayName = 'avatarPlaceHolder';
export default avatarPlaceHolder;
/* tslint:enable */
/* eslint-enable */
